<template>
  <div class="ai-block">
    <div class="ai-block-cons">
      <div class="ai-cons">
        <img src="../../../assets/images/home/img12.png" class="tip-img1" alt="">
        <div class="ai-cons-html">当前网络连接不稳定，此次搜索未成功，请再次尝试。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.ai-block {
  padding: 0 14px 20px;
  box-sizing: border-box;
  margin-top: 10px;

  .ai-block-cons {
    background: #F9F8F7;
    border-radius: 12px;
    padding: 12px 10px 1px 14px;
    box-sizing: border-box;

    .tip-img1 {
      height: 20px;
      display: block;
      margin-bottom: 10px;
    }

    .ai-cons-html {
      margin-bottom: 20px;
      font-size: 14px;
      color: #333;
      line-height: 24px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      transition: max-height 0.5s ease;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/OverTimeTip.vue